var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 191.11700439453125,
    height: 180.79600524902344,
    viewBox: "0 0 191.117 180.796",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0ac3aa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1574.372 -598.858)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a svg-elem-1",
    d: "M251.027,130.394H219.3c-.02.947-.072,1.886-.072,2.838,0,60.5,39.9,111.847,94.762,129.135V228.58a103.791,103.791,0,0,1-63.039-95.349c0-.952.046-1.892.072-2.838",
    transform: "translate(1451.495 468.464)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a svg-elem-2",
    d: "M271.754,133.232c0-.952-.052-1.89-.072-2.838H239.959c.026.945.072,1.886.072,2.838a103.788,103.788,0,0,1-64.632,96v33.613c55.679-16.789,96.355-68.528,96.355-129.609",
    transform: "translate(1398.973 468.464)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a svg-elem-3",
    width: 190.658,
    height: 31.336,
    transform: "translate(1574.401 748.318)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.ea4bb1f094ff5dd2c0ad6ed54e0dc856.svg";
export { ForwardRef as ReactComponent };